import React, { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { Card } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { AreaList } from "./component/AreaList.jsx"
import { FlatIconAndText } from "../../../../../component/atoms/FlaticonAndText/index.jsx"
import {
  getHistoryPlantingSeason,
  getHistoryPlantingSeasonHeader
} from "../../../../../redux/actions/AreaAction.jsx"
import { activityMonth, timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  checkAreaRegisteredValue,
  checkBadgePaymentStatus, fileTypeSplit,
  stringFormatting, toRupiah,
  toThousandConvert
} from "../../../../helpers/TextHelper.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { Skeleton } from "@material-ui/lab"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { useTranslation } from "react-i18next"
import Tooltip from "@material-ui/core/Tooltip"
import {
  AREA_REGISTERED_ENUM,
  DATE_TYPE_ENUM,
  ORDER_STATUS_PLANTING_ENUM,
  PLANT_TYPE_STRING,
  SORT_ORDER_STRING
} from "../../../../../constants/StringConstant.js"
import { FileList, Text2Row } from "../../../../../component/index.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/index.js"

export const AreaHistoryActivity = ({
  history,
  match: {
    params: { status, area_id, id }
  }
}) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { General, Area } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [sortOrder, setSortOrder] = useState("")
  const { t } = useTranslation()

  useEffect(() => {
    dispatch(getHistoryPlantingSeasonHeader(id))
  }, [])

  useEffect(() => {
    dispatch(getHistoryPlantingSeason(id, { pageReq: null }))
  }, [])

  useEffect(() => {
    if (Area?.data) {
      setDetail(Area?.data)
    }
  }, [Area])

  useEffect(() => {
    if (detail) {
      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(AREA_REGISTERED_ENUM.MT_ACTIVE),
          title: t("label_area_name")
        },
        {
          pathname:
            checkAreaRegisteredValue(status)
              ? RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status)
              : RoutesConstants.AREA.LIST_AREA_STATUS(status),
          title: checkAreaRegisteredValue(status)
              ? t("label_registered")
              : status
        },
        {
          pathname: RoutesConstants.AREA.LIST_AREA_STATUS(status) + "/" + area_id,
          title: detail?.area_name
        },
        {
          title:
            General.loading === false && detail?.start_date && detail?.end_date
              ? activityMonth(detail?.start_date, detail?.end_date)
              : ""
        }
      ])
    }
  }, [detail])

  const changePage = useCallback(
    (param) => {
      let newParam = {
        ...param
      };
      let Order = sortOrder === SORT_ORDER_STRING.DESC
        ? SORT_ORDER_STRING.ASC
        : SORT_ORDER_STRING.DESC;

      if (param.sortField) {
        newParam = {
          ...newParam,
          sort: param.sortField + "," + Order,
        };
      }

      dispatch(getHistoryPlantingSeason(id, { pageReq: newParam }));
      setSortOrder(Order);
    },
    [dispatch, id, sortOrder]
  );

  useEffect(() => {
    subHeader.setButton(true)
  }, [])

  const handleClickDetail = (id, type) => {
    if (type === ORDER_STATUS_PLANTING_ENUM.CLEARING_AREA.toLowerCase()) {
      history.push(
        RoutesConstants.AREA.DETAIL_ACTIVITY_LAND_CLEARING(
          status,
          area_id,
          id
        )
      )
    } else {
      history.push(RoutesConstants.AREA.DETAIL_ACTIVITY_TYPE_CUSTOM(status, area_id, type, id))
    }
  }

  function checkIcon(dataDetail) {
    if (dataDetail?.is_harvest_failure) {
      return dataDetail?.plant_type?.toLowerCase() === PLANT_TYPE_STRING.CORN ||
        dataDetail?.plant_type.toLowerCase() === PLANT_TYPE_STRING.PROD_CORN
        ? ICON_CONSTANTS.CORN_O_GRAY
        : ICON_CONSTANTS.PADDY_O_GRAY
    } else {
      return dataDetail?.plant_type?.toLowerCase() === PLANT_TYPE_STRING.PADDY
        ? ICON_CONSTANTS.PADDY_O
        : ICON_CONSTANTS.CORN_O
    }
  }

  return (
    <>
      <Card className={"mb-3"}>
        <CardBody>
          <div className={"d-flex justify-content-between w-full"}>
            <FlatIconAndText
              text={
                <span className="font-size-h3">
                  {t("planting_season")}{" "}
                  {General.loading === false && detail?.start_date && detail?.end_date
                    ? activityMonth(detail?.start_date, detail?.end_date)
                    : ""}{" "}
                  {detail?.is_harvest_failure && `(${t("label_failed_harvest")})`}
                </span>
              }
              svg={checkIcon(detail)}
            />
          </div>
          <RowModule>
            <div className="d-flex justify-content-start w-full mt-12">
              <div className="w-full">
                {General.loading ? (
                  Array.from({ length: 2 }).map((item, index) => {
                    return (
                      <div key={index} className="d-flex mt-8 flex-column flex-grow-1 pr-8">
                        <Skeleton animation="wave" variant={"text"} />
                        <Skeleton animation="wave" variant={"text"} />
                      </div>
                    )
                  })
                ) : (
                  <div className="d-flex justify-content-start mt-8">
                    <Text2Row
                      title={t("label_varietas")}
                      description={stringFormatting(detail?.variety)}
                      flexSize={"25%"}
                    />
                    <Text2Row
                      title={t("label_total_activities")}
                      description={stringFormatting(detail?.total_activity)}
                      flexSize={"25%"}
                    />
                    <Text2Row
                      title={t("label_confirmation_planting_season")}
                      description={stringFormatting(
                        timeStampToDate(
                          detail?.planting_season_created_date,
                          DATE_TYPE_ENUM.ISO_DATE_STRAP
                        )
                      )}
                      flexSize={"25%"}
                    />
                    {!detail?.is_harvest_failure && (
                      <Text2Row
                        title={
                          <div className={"d-flex"}>
                            <div className={"mr-2"}>{t("label_netto")}</div>
                            {detail?.plant_type &&
                              detail?.plant_type.toLowerCase() === PLANT_TYPE_STRING.PROD_CORN && (
                                <Tooltip
                                  arrow={true}
                                  placement={"top"}
                                  title={t("messages_alert_netto_alert_weight_slip")}>
                                  <img src={ICON_CONSTANTS.INFORMATION} alt={""} />
                                </Tooltip>
                              )}
                          </div>
                        }
                        description={stringFormatting(
                          detail?.is_seed_production
                            ? detail.netto && toThousandConvert(detail?.netto)
                            : detail?.total_harvest && toThousandConvert(detail?.total_harvest),
                          "Kg"
                        )}
                        flexSize={"25%"}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </RowModule>
        </CardBody>
      </Card>
        <Card className={"mb-3"}>
          <CardBody>
            <div className={"d-flex justify-content-between my-5"}>
              <h3 className={"text-uppercase"}>{t("details")}</h3>
              {detail?.payment_status && checkBadgePaymentStatus(detail?.payment_status)}
            </div>
            <div className={"separator separator-solid"} />
            <RowModule>
              <div className="d-flex justify-content-start w-full mt-6">
                <div className="w-full">
                  {General.loading ? (
                    Array.from({ length: 2 }).map((item, index) => {
                      return (
                        <div key={index} className="d-flex mt-6 flex-column flex-grow-1 pr-8">
                          <Skeleton animation="wave" variant={"text"} />
                          <Skeleton animation="wave" variant={"text"} />
                        </div>
                      )
                    })
                  ) : (
                    <div className="d-flex justify-content-start">
                      <Text2Row
                        title={t("label_total_revenue")}
                        description={toRupiah(detail?.total_income)}
                        flexSize={"25%"}
                      />
                      <Text2Row
                        title={t("due_date")}
                        description={detail?.payment_status ? (stringFormatting(
                          timeStampToDate(detail?.due_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
                        )) : "-"}
                        flexSize={"25%"}
                      />
                      <Text2Row
                        title={t("remaining_bill")}
                        description={toRupiah(detail?.remaining_bill)}
                        flexSize={"25%"}
                      />
                      <Text2Row
                        title={t("total_bills")}
                        description={toRupiah(detail?.total_bill)}
                        flexSize={"25%"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </RowModule>
          </CardBody>
        </Card>
      { detail?.payment_status && detail?.has_document  &&
        <Card className={"mb-3"}>
          <CardBody>
            <div className={"d-flex my-3"}>
              <SVG src={toAbsoluteUrl(ICON_CONSTANTS.NOTE_VIEW_WARNING_TRIANGEL)}/>
              <h3 className={"text-uppercase ml-3"}>{t("event_report")}</h3>
            </div>
            <div className={"separator separator-solid"} />
            <div className={"m-4"}>
              <RowModule>
                <div>
                  <h4>{t("label_reason")}</h4>
                  <Card bg={"secondary"}>
                      <div className={"w-full min-h-80px my-3 mx-4"}>{stringFormatting(detail?.document_reason)}</div>
                  </Card>
                </div>
                <div>
                  <h4>{t("support_document")}</h4>
                  <FileList
                    view={stringFormatting(detail?.document_url)}
                    className={"mb-5"}
                    onNewTab={true}
                    name={stringFormatting(detail?.document_name)}
                    size={stringFormatting(detail?.document_size)}
                    type={fileTypeSplit(stringFormatting(detail?.document_name))}
                  />
                </div>
              </RowModule>
            </div>
          </CardBody>
        </Card>
      }
      <Card>
        <RowModule>
          <AreaList
            data={Area}
            general={General}
            changePage={changePage}
            onClickDetail={handleClickDetail}
            history={history}
            payment={detail?.payment_status}
          />
        </RowModule>
      </Card>
    </>
  )
}